import { render, staticRenderFns } from "./AudioRecordingView.vue?vue&type=template&id=640fa44f&scoped=true&"
import script from "./AudioRecordingView.vue?vue&type=script&lang=ts&"
export * from "./AudioRecordingView.vue?vue&type=script&lang=ts&"
import style0 from "./AudioRecordingView.vue?vue&type=style&index=0&id=640fa44f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640fa44f",
  null
  
)

export default component.exports